module.exports = __webpack_public_path__ + "static/media/cashfree.50e74835.svg";